import { api } from "./client";

export interface QualificationFieldDto {
  id: string;
  label: string;
  displayOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt?: string | null;
}

export interface UpsertQualificationFieldPayload {
  label: string;
  displayOrder: number;
  isActive: boolean;
}

export const qualificationFieldsApi = {
  /** Any authed user — Submit Qualification form uses this. */
  active: () => api.get<QualificationFieldDto[]>("/qualification-fields/active"),

  // Admin-only
  all: () => api.get<QualificationFieldDto[]>("/admin/qualification-fields"),
  create: (body: UpsertQualificationFieldPayload) =>
    api.post<QualificationFieldDto>("/admin/qualification-fields", body),
  update: (id: string, body: UpsertQualificationFieldPayload) =>
    api.put<QualificationFieldDto>(`/admin/qualification-fields/${id}`, body),
  reorder: (orderedIds: string[]) =>
    api.put<QualificationFieldDto[]>("/admin/qualification-fields/reorder", { orderedIds }),
};
